import type { Tenant } from '@/services/http/tenantService/types'
import { TENANT_COOKIE } from '../constants'

export async function getTenantByCookies(): Promise<Tenant | null> {
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers')
    const tenant = cookies().get(TENANT_COOKIE)?.value

    return JSON.parse(tenant || 'null')
  }

  const Cookies = (await import('js-cookie')).default
  const tenant = Cookies.get(TENANT_COOKIE)

  return JSON.parse(tenant || 'null')
}
